import { render, staticRenderFns } from "./BuildInfo.vue?vue&type=template&id=1c502c2c&scoped=true&"
import script from "./BuildInfo.vue?vue&type=script&lang=js&"
export * from "./BuildInfo.vue?vue&type=script&lang=js&"
import style0 from "./BuildInfo.vue?vue&type=style&index=0&id=1c502c2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c502c2c",
  null
  
)

export default component.exports